var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3616 21.1204C15.3616 19.5297 14.0723 18.2404 12.4816 18.2404C10.8908 18.2404 9.60156 19.5297 9.60156 21.1204V30.7204C9.60156 38.673 16.0489 45.1204 24.0016 45.1204C31.9542 45.1204 38.4016 38.673 38.4016 30.7204V23.0404C38.4016 21.4497 37.1123 20.1604 35.5216 20.1604C33.9308 20.1604 32.6416 21.4497 32.6416 23.0404V21.1204C32.6416 19.5297 31.3523 18.2404 29.7616 18.2404C28.1708 18.2404 26.8816 19.5297 26.8816 21.1204V19.2004C26.8816 17.6097 25.5923 16.3204 24.0016 16.3204C22.4108 16.3204 21.1216 17.6097 21.1216 19.2004V5.76037C21.1216 4.16965 19.8323 2.88037 18.2416 2.88037C16.6508 2.88037 15.3616 4.16965 15.3616 5.76037V27.8404V21.1204Z",
    stroke: "#353535",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 15.3604V1.92041",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3616 12.4805L36.4816 15.3605L33.6016 12.4805",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3616 4.80041L36.4816 1.92041L33.6016 4.80041",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "adreel-static/media/f1.2ae0c0ce6ea998f68784c4ea60f14c08.svg";
export { ForwardRef as ReactComponent };